import '../SignUp/index.scss';
import './index.scss';
import React, { useContext, useEffect, useState } from 'react';
import { bool, func } from 'prop-types';
import { Link, useHistory } from 'react-router-dom';
import _ from 'lodash';
import { signUp, validateMail } from '../../services/Api/User/UserService';
import LoginToaster from '../SignUp/LoginToaster.jsx';
import { Errors } from '../../constants/errors';
import SignupForm from '../SignUp/SignupForm';
import {
  SIGNUP_STATE,
  DEFAULT_PASSWORD_STATE,
  INTELLIMIZE_LOYALTY_SIGN_UP_EVENT,
  INTELLIMIZE_GENIUS_SIGN_UP_EVENT,
  BONUS_PRICE
} from '../../constants/defaults';
import PasswordModal from '../common/PasswordModal';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { AuthContext } from '../../Contexts';

const SignupModal = ({
  closeSignupModal,
  isFromHomeDelivery,
  hideSignUpOpenFlashModal
}) => {
  const [signUpData, setSignUpData] = useState({
    ...SIGNUP_STATE,
    ...DEFAULT_PASSWORD_STATE
  });
  const [showLoader, setLoader] = useState(false);
  const [showNotification, setNotification] = useState(false);
  const [notificationError, setnotificationError] = useState('');
  const [showToaster, setToaster] = useState(false);
  const [toastermessage, setToastermessage] = useState('');
  const [isPasswordModal, setIsPasswordModal] = useState(false);
  const [pwdLoader, setPwdLoader] = useState(false);
  const { FName, LName, birthDate, Email, password } = signUpData;
  const history = useHistory();
  const { t, i18n } = useTranslation();
  let lang = i18n.language;
  const dispatch = useDispatch();
  const modalState = useSelector(state => state.modal.modal);
  const context = useContext(AuthContext);
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);

  const submit = async () => {
    let { signUpPath } = _.getSignUpPath(modalState);
    await setPwdLoader(true);
    _.triggerGTMVirtualPageViewEvent({
      event: 'signUpSubmitClick',
      formId: 'sign up',
      clickText: 'Sign up',
      ...signUpPath
    });

    const splitDate = !_.isEmpty(birthDate) && birthDate.split('/');
    const apiDate = `${splitDate[2]}/${splitDate[0]}/${splitDate[1]}`;
    const signUpData = {
      firstName: FName.trim(),
      lastName: LName.trim(),
      email: Email.trim(),
      birthDate: apiDate,
      password,
      tenantId: 0,
      acceptAgreement: true
    };
    if (isFromHomeDelivery) signUpData.subSource = 'sc-geniusrx';
    try {
      const signupResponse = await signUp(signUpData);
      const { response } = signupResponse;
      if (response && response.status === 409) {
        setPwdLoader(false);
        setToaster(true);
        resetPwdData();
        setToastermessage(response.data.message);
        return;
      }
      if (response && response.status >= 400) {
        setNotification(true);
        setPwdLoader(false);
        setnotificationError(response.data.message);
        resetPwdData();
        setTimeout(() => {
          setNotification(false);
        }, 5000);
        return;
      }
      if (signupResponse.data && !_.isEmpty(signupResponse.data)) {
        resetPwdData();
        closeSignupModal();
        context?.setUserData(signupResponse.data);
        _.setUserData({ signupResponse }, dispatch);
        _.setUserPoints({ signupResponse }, dispatch);
        if (isFromHomeDelivery) {
          _.sendIntellimizeEvent(INTELLIMIZE_GENIUS_SIGN_UP_EVENT);
          hideSignUpOpenFlashModal();
        } else {
          document.body.style.overflow = '';
          _.triggerGTMVirtualPageViewEvent({
            event: 'signUpSuccess',
            formId: 'sign up',
            ...signUpPath
          });
          _.sendIntellimizeEvent(INTELLIMIZE_LOYALTY_SIGN_UP_EVENT);
          history.location.pathname.match(
            /how-it-works|como-funciona-singlecare/
          ) && history.push(_.withLocale(lang, '/'));
          //: window.location.reload();
        }
      }
    } catch (err) {
      setPwdLoader(false);
      await resetPwdData();
      await setNotification(true);
      await setnotificationError(
        err.response.data ? err.response.data.message : 'Something went wrong.'
      );
      setTimeout(() => {
        setNotification(false);
      }, 5000);
    }
  };

  const hideNotification = event => {
    event.preventDefault();
    setNotification(false);
  };

  const hideToaster = event => {
    event.preventDefault();
    setToaster(false);
  };

  const resetPwdData = () => {
    setSignUpData({
      ...signUpData,
      ...DEFAULT_PASSWORD_STATE
    });
    setIsPasswordModal(false);
  };

  const onGetStartedClick = async e => {
    e.preventDefault();
    await setLoader(true);
    const responseData = await validateMail(Email);
    if (responseData && _.isEqual(responseData.result, 'undeliverable')) {
      setSignUpData({
        ...signUpData,
        EmailErr: Errors.Email,
        emailKickboxErr: true
      });
    } else {
      setIsPasswordModal(true);
    }
    setLoader(false);
  };
  return (
    <div className="sc-signup-main signupContainer">
      <div className={`notification ${showNotification ? 'visible' : ''}`}>
        {t(notificationError)}
        <span className="close-button" onClick={hideNotification}>
          ×
        </span>
      </div>
      <div className="signupBanner">
        <h1>
          {t('Save an')}
          <strong>
            &nbsp;{t('extra bonus', { bonusPrice: BONUS_PRICE })}&nbsp;
          </strong>
          {t('on')}
          {this.props.isMobileDevice && <br className="mobile-only" />}
          &nbsp;{t('this prescription instantly!')}
        </h1>
        <div onClick={closeSignupModal} className="closeModal">
          <img
            src="/content/images/icons/close.svg"
            className="close-button"
            alt=""
            aria-hidden="true"
          />
        </div>
      </div>
      <div className="sc-signup--step1">
        <div className="step1-form">
          <div className="SignupLeftSection">
            <div className="SignInfoSection textCenter">
              <div className="offerList">
                <p>
                  <strong>
                    {t('An extra bonus', { bonusPrice: BONUS_PRICE })}
                  </strong>
                  <br />
                  {t('off')}&nbsp;
                  {t('your next prescription*')}
                </p>
              </div>
              <div className="offerList">
                <p>
                  <strong>{t('Member only')}</strong> <br />
                  {t('bonus savings')}
                </p>
              </div>
            </div>
            <form
              id="signup-form"
              role="form"
              method="post"
              name="signup"
              className="invalid commonForm"
            >
              <div className="enroll-signup">
                <div className={`${showToaster && 'pointerNone'}`}>
                  <SignupForm
                    formData={signUpData}
                    handleFormState={setSignUpData}
                  />
                </div>
                {showToaster ? (
                  <LoginToaster
                    hideToaster={hideToaster}
                    message={toastermessage}
                    firstName={FName}
                    lastName={LName}
                    closeSignupModal={closeSignupModal}
                    isFromDrugPage={true}
                  />
                ) : (
                  <section className="signup-footer">
                    <div className="step1-form-cta">
                      <p className="step1-form--submit has-loading textCenter">
                        {showLoader ? (
                          <img
                            src="/content/images/loader/loading.gif"
                            alt="loader"
                            className="searchBarLoader"
                          />
                        ) : (
                          <button
                            className="sc-btn-cyan step1-submit has-loading-btn button pink fullwidth"
                            disabled={!_.isSignupFormValid(signUpData)}
                            onClick={onGetStartedClick}
                          >
                            {t('Get started')}
                          </button>
                        )}
                        <span className="sc-btn-cyan loading-btn hide" />
                      </p>
                    </div>
                    <div className="helper-text">
                      <p>
                        {t('sm-*Some exclusions apply. See')}{' '}
                        <Link
                          target="_blank"
                          to={_.withLocale(lang, '/terms-and-conditions')}
                          onClick={closeSignupModal}
                        >
                          {' '}
                          {t('sm-terms and conditions.')}.
                        </Link>
                        <br />
                        *&nbsp;{t('sm-Required')}
                      </p>
                    </div>
                  </section>
                )}
              </div>
              <input id="SignUpFormViewModel_ReturnUrl" type="hidden" />
            </form>
          </div>
        </div>
        {isPasswordModal && (
          <PasswordModal
            formData={signUpData}
            handleFormState={setSignUpData}
            closePasswordModal={() => resetPwdData()}
            submitForm={submit}
            pwdLoader={pwdLoader}
          />
        )}
      </div>
    </div>
  );
};

SignupModal.propTypes = {
  closeSignupModal: func,
  isFromHomeDelivery: bool,
  hideSignUpOpenFlashModal: bool,
  isMobileDevice: bool
};

SignupModal.defaultProps = {
  closeSignupModal: () => {},
  isFromHomeDelivery: false,
  hideSignUpOpenFlashModal: () => {},
  isMobileDevice: false
};

export default SignupModal;
